import {AlpineComponent} from 'alpinejs';

type SendToDataLayer = {}

export default (): AlpineComponent<SendToDataLayer> => ({
  init() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'lead_form_submit'
    });
    console.log('✅ Event pushed to dataLayer');
  }
});
